import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileItem from './ItemMobile';
import Item from './Item';
import useBreakpoints from '../../../../hooks/useBreakpoints';
import useMediaQuery from '../../../../hooks/useMediaQuery';

interface ItemProps {
  button: string;
  description: string;
  icon: React.JSX.Element;
  setShowModal: (show: boolean) => void;
  title: string;
}

const OnboardingItem: FC<ItemProps> = ({
  button,
  description,
  icon,
  setShowModal,
  title,
}) => {
  const navigate = useNavigate();
  const breakpoints = useBreakpoints();
  const isSmAndDown = useMediaQuery(breakpoints.down('sm'));
  const handleClick = () => {
    setShowModal(false);
    switch (button) {
      case 'Open a ticket':
        return navigate('/forms');
      case 'Search articles':
        return navigate('/search');
      case 'View my tickets':
        return navigate('/tickets');
      case 'View equipment':
        return navigate('/equipment');
      default:
        return navigate('/forms');
    }
  };
  return isSmAndDown ? (
    <MobileItem
      button={button}
      description={description}
      icon={icon}
      handleClick={handleClick}
      title={title}
    />
  ) : (
    <Item
      button={button}
      description={description}
      icon={icon}
      handleClick={handleClick}
      title={title}
    />
  );
};

export default OnboardingItem;
